import { BaseNodeStrategy } from './BaseNodeStrategy';

/**
 * Strategy for Normal node type.
 * Uses all base defaults: 64x32 size, node-completed/node-upcoming textures, supports outline.
 */
export class NormalNodeStrategy extends BaseNodeStrategy {
  // All defaults from BaseNodeStrategy are correct for Normal nodes
}
